module.exports = __webpack_public_path__ + "img/light_footer_img2.aaf70cc3.png";